import moment from 'moment';
import queryString from 'qs';

const getExportReportAttendanceHostRequest = (filter) => {
  const queries = {};

  if (filter?.search) queries['search'] = filter.search;
  if (filter?.startedAt) queries['startedAt'] = moment(filter.startedAt).format('YYYY-MM-DD');
  if (filter?.endedAt) queries['endedAt'] = moment(filter.endedAt).format('YYYY-MM-DD');
  if (filter?.brand?.length) queries['brandName'] = filter.brand?.map((brand) => brand.value);

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getExportReportAttendanceHostRequest;
